// extracted by css-extract-rspack-plugin
export default {"softBlockerContainer":"IFzfvAeiwSQfFKt9"};